export default __webpack_public_path__ + "static/media/i-documento - ins.cce7a558.svg";